export default "__VITE_ASSET__DoQRp$8z__"